import { createPayload, updatePayload, type PayloadSpec } from '../../../lib/forms/payload.js';

export const EXCHANGE_RATE_PAYLOAD_SPEC: PayloadSpec = {
  required: ['baseCurrency', 'quoteCurrency', 'rate', 'source'],
  optional: ['effectiveAt', 'expiresAt'],
  numeric: [],
  createOnly: ['baseCurrency', 'quoteCurrency'],
};

export function buildCreateExchangeRatePayload(
  values: Record<string, unknown>,
): Record<string, unknown> {
  const payload = createPayload(values, EXCHANGE_RATE_PAYLOAD_SPEC);
  return payload;
}

export function buildUpdateExchangeRatePayload(
  values: Record<string, unknown>,
  version: number,
): Record<string, unknown> {
  const payload = updatePayload(values, EXCHANGE_RATE_PAYLOAD_SPEC, version);

  // updatePayload sends an empty optional as null, but the service treats these
  // as optional/partial fields and does not accept null.
  if (payload.effectiveAt === null) {
    delete payload.effectiveAt;
  }
  if (payload.expiresAt === null) {
    delete payload.expiresAt;
  }

  return payload;
}
